import React from "react"
import autobind from "class-autobind"
import strings from "../../../../localization/strings"
import { Paper, CircularProgress, SelectField, MenuItem} from "material-ui"
import DateRangeSelect_SelectWeek from "../../../../components/common/DateRangeSelect_SelectWeek"
import { EDayOfWeek, IDate, IPayrollPayCalendar, IScheduleDocument } from "../../../../models"
import moment from "moment"
import * as api from "../../../../api"
import HierarchySettingsStore from "../../../../stores/HierarchySettingsStore"
import { IWorkforceAssessmentDashboard, IWorkforceAssessmentDashboardHierarchySummary, IWorkforceAssessmentDashboardJobSummary, IWorkforceAssessmentDashboardPositionSummary } from "../../../../models/data/dashboard/WorkforceAssessment/WorkforceAssessmentDashboard"
import numeral from "numeral"
import * as utils from "../../../../helpers/utils"
import ScheduleBudgetCostSavingsDrawer from "../../../../components/schedule/detail/ScheduleBudgetCostSavingsDrawer"
import { IScheduleBudgetInfo } from "../../../../models/data/scheduling/ScheduleBudgetInfo"
import AccountStore from "../../../../stores/AccountStore"
import LeftWaveData from "./LeftWaveData"
import WaveGraph from "./WaveGraph"
import TotalWaveData from "./TotalWaveData"
import SubTotalsWaveData from "./SubTotalsWaveData"

declare global {
    interface Window {
        Intercom: any
    }
}
interface IProps {
}

interface IState {
    loading: boolean
    calculating: boolean
    startDate: IDate
    endDate: IDate
    data: IWorkforceAssessmentDashboard
    showSavingsDrawer: boolean
    selectedScheduleBudgetInfo: IScheduleBudgetInfo
    selectedCostSavingsDrawerName: string
    activeDashboard: string
}

export default class CostSavingsWave extends React.Component<IProps, IState> {    
    constructor(props) {
        super(props)
        const calcualteStartEndDateLocalUTCFormat = this.getCalcualteStartEndDateLocalUTCFormat()
        this.state = {
            loading: true,
            calculating: false,
            startDate: localStorage.getItem("findd_dashboard_startDate") ? localStorage.getItem("findd_dashboard_startDate") : calcualteStartEndDateLocalUTCFormat.calcualteStartDateLocalUTCFormat,
            endDate: localStorage.getItem("findd_dashboard_endDate") ? localStorage.getItem("findd_dashboard_endDate") : calcualteStartEndDateLocalUTCFormat.calcualteEndDateLocalUTCFormat,
            data: null,
            showSavingsDrawer: false,
            selectedScheduleBudgetInfo: null,
            selectedCostSavingsDrawerName: null,
            activeDashboard: "wfo"
        }
        autobind(this)
    }

    getCalcualteStartEndDateLocalUTCFormat() {
        let calcualteStartDateLocalUTCFormat = null
        let calcualteEndDateLocalUTCFormat = null

        calcualteStartDateLocalUTCFormat = moment().startOf("day").utc(true).format()
        calcualteEndDateLocalUTCFormat = moment().add(1, "week").utc(true).format()

        return { calcualteStartDateLocalUTCFormat, calcualteEndDateLocalUTCFormat }
    }

    componentDidMount() {
        document.title = `${strings.Dashboard} | Workforce Assessment`
        HierarchySettingsStore.on("global_change", this.fetchData)        
        this.fetchData()
    }

    fetchData(){
        this.setState({data: null, loading: true},()=>{
            api.getWorkforceAssessmentDashboard(HierarchySettingsStore.getGlobalLevelItemFilterId(), this.state.startDate.toString(), this.state.endDate.toString()).then(result => {
                this.setState({data: result.data, loading: false})
            });    
        })
    }

    componentWillUnmount() {
        HierarchySettingsStore.removeListener("global_change", this.fetchData)
    }

    getSavingsItemsData(totalLaborCost, optimizationSavings, productivitySavings, administrativeSavings) {
        let optimizationSavingsList = [optimizationSavings*.4, optimizationSavings*.2, optimizationSavings*.1, optimizationSavings*.3]
        let productivitySavingsList = [productivitySavings*.4, productivitySavings*.25, productivitySavings*.35]
        let administrativeSavingsList = [administrativeSavings*.6, administrativeSavings*.4]

        return [
                {
                  EstimatedOptimizationSavings: optimizationSavingsList[0],
                  EstimatedOptimizationText: [
                    "Staff Planning",
                    "Skill-based Staff Ratios"
                  ],
                  EstimatedProductivitySavings: 0,
                  EstimatedProductivityText: [],
                  EstimatedAdministrativeSavings: 0,
                  EstimatedAdministrativeText: [],
                  EstimatedTotalSavings: optimizationSavingsList[0]
                },
                {
                  EstimatedOptimizationSavings: optimizationSavingsList[1],
                  EstimatedOptimizationText: [
                    "AI Census Forecasting",
                    "Schedule to Staff Plan"
                  ],
                  EstimatedProductivitySavings: productivitySavingsList[0],
                  EstimatedProductivityText: [
                    "Schedule Flexibility"
                  ],
                  EstimatedAdministrativeSavings: administrativeSavingsList[0],
                  EstimatedAdministrativeText: [
                    "Schedule Efficiency Gains"
                  ],
                  EstimatedTotalSavings: optimizationSavingsList[1]+productivitySavingsList[0]+administrativeSavingsList[0]
                },
                {
                  EstimatedOptimizationSavings: optimizationSavingsList[2],
                  EstimatedOptimizationText: [
                    "AI-based Labor Shortage Forecasting"
                  ],
                  EstimatedProductivitySavings: productivitySavingsList[1],
                  EstimatedProductivityText: [
                    "Satisfaction & Performance"
                  ],
                  EstimatedAdministrativeSavings: administrativeSavingsList[1],
                  EstimatedAdministrativeText: [
                    "Time Tracking Optimization"
                  ],
                  EstimatedTotalSavings: optimizationSavingsList[2]+productivitySavingsList[1]+administrativeSavingsList[1]
                },
                {
                  EstimatedOptimizationSavings: optimizationSavingsList[3],
                  EstimatedOptimizationText: [
                    "GigPool",
                    ""
                  ],
                  EstimatedProductivitySavings: productivitySavingsList[2],
                  EstimatedProductivityText: [
                    "Increase Retention"
                  ],
                  EstimatedAdministrativeSavings: 0,
                  EstimatedAdministrativeText: [],
                  EstimatedTotalSavings: optimizationSavingsList[3]+productivitySavingsList[2]
                }
              ]
    }

    render() {
        let yearlyLaborCosts = 1275000000
        let optimizationSavings = yearlyLaborCosts * .18
        let productivitySavings = yearlyLaborCosts * .09
        let administrativeSavings = yearlyLaborCosts * .05
        let totalSavings = optimizationSavings + productivitySavings + administrativeSavings

        return (
            <div>
                {this.state.data && !this.state.loading &&
                    <div>
                        <div style={{display: "grid", gridTemplateColumns: "min-content auto"}}>
                            <div style={{gridRow: 1, gridColumn: 1, paddingTop: 48, borderRight: "solid 1px #efefef"}}>
                                <LeftWaveData 
                                    yearlyLaborCosts={yearlyLaborCosts} 
                                    optimizationSavings={optimizationSavings} 
                                    productivitySavings={productivitySavings} 
                                    administrativeSavings={administrativeSavings}                                
                                />
                            </div>
                            <div style={{gridRow: 1, gridColumn: 2, paddingLeft: 20}}>
                                <WaveGraph />
                            </div>
                            <div style={{gridRow: 2, gridColumn: 1, borderRight: "solid 1px #efefef"}}>
                                <TotalWaveData totalSavings={totalSavings} />
                            </div>
                            <div style={{gridRow: 2, gridColumn: 2, paddingLeft: 20, marginTop: -9,}}>
                                <SubTotalsWaveData savingsList={this.getSavingsItemsData(yearlyLaborCosts,optimizationSavings, productivitySavings, administrativeSavings)} />
                            </div>                            
                        </div>
                    </div>
                }

                {this.state.loading &&
                    <div className="spinner">
                        <CircularProgress />
                    </div> 
                }

                {this.state.showSavingsDrawer && this.state.selectedScheduleBudgetInfo &&
                    <ScheduleBudgetCostSavingsDrawer 
                        name={this.state.selectedCostSavingsDrawerName} 
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        bi={this.state.selectedScheduleBudgetInfo}      
                        open={this.state.showSavingsDrawer} 
                        handleClose={()=> this.setState({showSavingsDrawer: false})}
                    />
                }
            </div>
        )
    }
}